"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryBooleans = void 0;
var QueryBooleans;
(function (QueryBooleans) {
    QueryBooleans["TRUE"] = "true";
    QueryBooleans["FALSE"] = "false";
})(QueryBooleans || (exports.QueryBooleans = QueryBooleans = {}));
